import {Injectable} from '@angular/core';
import {CookieNames} from "../../shared/cookie/cookie-names";
import {Subject} from "rxjs";
import {CcStorageService} from "../common/cc-storage.service";
import {CspStyleManager} from "../../utils/csp-renderer";

export const colorsTheme = {
  'lightcyan': '#42BB9C',
  'cyan': '#4FC5C1',
  'darkcyan': '#147483',
  'darkercyan': '#11655e',
  'light-yellow': '#ffd500',
  'dark-light-yellow': '#ad9300',
  'dark-dark-light-yellow': '#524300',
  'yellow': '#ffc916',
  'yellow-less': '#e3c913',
  'light-orange': '#D29300',
  'orange': '#ea792d',
  'darkorange': '#a27106',
  'darkerorange': '#2c190d',
  'customblue': '#333F50',
  'white': '#ffffff',
  'white-light': '#F1F4F4',
  'white-grey': '#eeeeee',
  'white-grey-alt': '#f1f4f4',
  'white-blue': 'rgba(228, 244, 255, 0.9)',
  // 'white-blue': 'rgba(228, 244, 255, 0.56)',
  'lighter-grey-alt': '#e2e2e2',
  'lighter-grey': '#cecece',
  'lightgrey': '#a3a3a3',
  'grey': '#a2a2a2',
  'darkgrey': '#575757',
  'black': '#000000',
  'alternativeblack': '#121416',
  'lightblack': '#1A1A1A',
  'enovea-green': '#B3EBA2',
  'enovea-green-dark': '#1c4111',
  'grass-green': '#3A9D23',
  'darkgrass-green': '#2e7c1c',
  'default-green': '#86cd82',
  'default-darkgreen': '#43995a',
  'captionblue': '#062D52',
  'captionblue2': '#093656',
  'captionblue_transp': '#062d529c',
  'grey-highlight': '#BBC8CA',
  'grey-blue': '#dde4e5',
  'grey-blueer': '#99bccc',
  'grey-no': '#799296',
  'grey-inactive': '#C8D7D9',
  'grey-inactive-letter': '#5E7275',
  'bordergrey': '#707070',
  'grey-execution-card': '#EFEFEF',
  'lightercyan': '#C3EDF5',
  'button-rectangular-grey-disable-text-color': '#799296',
  'lighter-red': '#e29ca9',
  'light-red': '#d58783',
  'red-table': '#c7342c',
  'red': '#c52c27',
  'red-light': '#e85852',
  'darkred': '#621613',
  'tomatored': '#bc5b2e',
  'tomatoredlight': '#dc7c4b',
  'darktomatored': '#9d451c',
  'oranged': '#bc832e',
  'darkoranged': '#9d691c',
  'skyblue': '#06bafd',
  '/$skyblue': '#2f85bd',
  'tableblue': '#71accd',
  'lighttableblue': '#92c0dc',
  'lightlighttableblue': '#a3ccde',
  'lesslightblue2': '#293d56',
  'lesslightblue': '#283a50',
  'lesslesslightblue2': '#2c4260',
  'lesslesslightblue': '#2b3e56',
  'lightblue': '#1E618C',
  'lightblue-less': '#1c5a83',
  'lightblue-less-less': '#195073',
  'lighterblue': '#328bbd',
  'simple-blue': '#1295c7',
  'loading-bar': 'rgba(33, 144, 195, 0.51)',
  'blue': '#1f2d40',
  'darkLightblue': '#17496a',
  'darkblue': '#343e4d',
  'darkerblue': '#2a323d',
  'blackblue': '#1c2129',
  'greyblue': '#263446',
  'seablue': '#4D97C0',
  'lightgreyblue': '#839aa8',
};
export const darkTheme = {
  'side_bar_bkgrnd': colorsTheme['blue'],
  'side_bar_txt': colorsTheme['grey-no'],
  'side_bar_button_txt': colorsTheme['white-blue'],
  'side_bar_button_active_bkgrnd': colorsTheme['blackblue'],
  'side_bar_button_hover_bkgrnd': colorsTheme['captionblue'],

  'splitter_bkgrnd': colorsTheme['blue'],
  'splitter_brdr': colorsTheme['darkblue'],

  'table_menu_header_bkgrnd': colorsTheme['lightblue'],
  'table_menu_header_txt': colorsTheme['white-grey'],
  'table_menu_header_brdr': colorsTheme['darkblue'],

  'table_menu_footer_bkgrnd': colorsTheme['blackblue'],
  'table_menu_footer_txt': colorsTheme['white-grey'],

  'table_header_bkgrnd': colorsTheme['blackblue'],
  'table_header_brdr': colorsTheme['darkblue'],
  'table_header_txt': colorsTheme['white-grey'],
  'table_header_wght': '700',
  'table-header-shadow': 'rgba(5,9,9,0.74)',

  'table_row_bkgrnd_odd': colorsTheme['blue'],
  'table_row_bkgrnd_event': colorsTheme['greyblue'],
  'table_row_txt': colorsTheme['white-grey'],
  'table_row_wght': '600',

  'table_row_highlight_bkgrnd_odd': colorsTheme['lightblue-less-less'],
  'table_row_highlight_bkgrnd_event': colorsTheme['lightblue-less'],
  'table_row_highlight_txt': colorsTheme['white-grey'],

  'table-sort-color': colorsTheme['lighterblue'],
  'table-sort-hover-color': colorsTheme['simple-blue'],
  'table-filter-color': colorsTheme['light-yellow'],
  'table-filter-hover-color': colorsTheme['yellow-less'],

  'dialog_bkgrnd': colorsTheme['blue'],
  'dialog_bkgrnd2': colorsTheme['darkblue'],
  'dialog_bkgrnd3': colorsTheme['lightblue-less-less'],
  'dialog_txt': colorsTheme['white-grey'],
  'dialog_brdr': colorsTheme['darkblue'],

  'global_input_bkgrnd': colorsTheme['blue'],
  'global_input_bkgrnd2': colorsTheme['blackblue'],
  'global_input_bkgrnd3': '#5f5f6c',
  'global_input_txt': colorsTheme['white-grey'],
  'global_input_hover_txt': colorsTheme['white-grewhite-grey-alt'],
  'global_input_txt2': colorsTheme['lightercyan'],
  'global_input_txt3': '#43597d',
  'global_input_highlight': '#ffff8f',
  'global_input_brdr': colorsTheme['greyblue'],
  'global_input_brdr2': colorsTheme['lesslesslightblue2'],
  'global_input_brdr3': colorsTheme['lesslightblue'],

  'global_button_bkgrnd':  colorsTheme['blue'],
  'global_button_bkgrnd2':  colorsTheme['lightblue-less-less'],
  'global_button_brdr':  colorsTheme['darkLightblue'],
  'global_button_brdr2':  colorsTheme['lightblue'],
  'global_button_txt': colorsTheme['lightercyan'],
  'global_button_txt2': colorsTheme['grey-blueer'],
  'global_button_txt_hover': colorsTheme['grey-blueer'],
  'global_button_txt_hover2': colorsTheme['lightercyan'],
  'global_button_success_bk': colorsTheme['default-darkgreen'],
  'global_button_danger_bk': colorsTheme['tomatored'],
  // 'global_button_bkgrnd_brdr':  colorsTheme['darkblue'],

  // main layout Colors
  'main-background': colorsTheme['darkerblue'],
  // Header Colors
  'header-background': colorsTheme['darkblue'],
  'header-color': colorsTheme['cyan'],
  'active-background': colorsTheme['lightblue'],
  'active-color': colorsTheme['white'],
  'active-color-dark': colorsTheme['grey-highlight'],
  'exit-color': colorsTheme['white'],
  'logo-background': colorsTheme['darkblue'],
  'logo-color': colorsTheme['darkblue'],

  'enovea-green': colorsTheme['enovea-green'],
  'tomato':'tomato',
  'orange': colorsTheme['orange'],
  'steelblue': 'steelblue',
  'lightsteelblue': 'lightsteelblue',
  'palegreen': 'palegreen',
  'yellow': colorsTheme['yellow'],
  'deepskyblue': 'deepskyblue',
  'yellowgreen': 'YellowGreen',
  'tomatored': colorsTheme['tomatored'],
  'grass-green': colorsTheme['grass-green'],
  'light-orange': colorsTheme['light-orange'],
  'light-yellow': colorsTheme['light-yellow'],
  'indianred': 'indianRed',
  'darkorange': 'darkorange',
  'dodgerblue': 'dodgerblue',
  'lightyellow': 'lightyellow',
  'gainsboro': 'gainsboro',
  'darkseagreen': '#417841',
  'cornflowerblue': '#4c6da9',
  'invalid': colorsTheme['light-red'],
  'info': colorsTheme['grey-blueer'],
  'yellowgreenBk': '#71952a',
  'tomatoBk':'#9b3a28',
};

export const lightTheme = {
  'side_bar_bkgrnd': colorsTheme['blue'],
  'side_bar_txt': colorsTheme['grey-no'],
  'side_bar_button_txt': colorsTheme['white-blue'],
  'side_bar_button_active_bkgrnd': colorsTheme['blackblue'],
  'side_bar_button_hover_bkgrnd': colorsTheme['captionblue'],
  // 'side_bar_bkgrnd':  colorsTheme['grey-blue'],
  // 'side_bar_txt':  colorsTheme['blackblue'],
  // 'side_bar_button_txt':  colorsTheme['blue'],
  // 'side_bar_button_active_bkgrnd':  colorsTheme['grey-no'],
  // 'side_bar_button_hover_bkgrnd':  colorsTheme['lightblue'],

  'splitter_bkgrnd': colorsTheme['grey-blue'],
  'splitter_brdr': colorsTheme['darkblue'],

  // 'table_menu_header_bkgrnd': colorsTheme['lightgreyblue'],
  // 'table_menu_header_txt':  colorsTheme['blackblue'],
  // 'table_menu_header_brdr':  colorsTheme['darkblue'],

  'table_menu_header_bkgrnd': colorsTheme['lightblue'],
  'table_menu_header_txt': colorsTheme['white-grey'],
  'table_menu_header_brdr': colorsTheme['darkblue'],

  'table_menu_footer_bkgrnd': colorsTheme['blackblue'],
  'table_menu_footer_txt': colorsTheme['white-grey'],

  'table_header_bkgrnd': colorsTheme['grey'],
  'table_header_brdr': colorsTheme['darkgrey'],
  'table_header_txt': colorsTheme['blackblue'],
  'table_header_wght': '700',
  'table-header-shadow': 'rgba(27,40,45,0.74)',

  'table_row_bkgrnd_odd': colorsTheme['white'],
  'table_row_bkgrnd_event': colorsTheme['grey-blue'],
  'table_row_txt': colorsTheme['black'],
  'table_row_wght': '700',

  'table_row_highlight_bkgrnd_odd': colorsTheme['lightlighttableblue'],
  'table_row_highlight_bkgrnd_event': colorsTheme['lighttableblue'],
  'table_row_highlight_txt': colorsTheme['black'],

  'table-sort-color': '#068bfd',
  'table-sort-hover-color': '#1a99ff',
  'table-filter-color': colorsTheme['yellow'],
  'table-filter-hover-color': colorsTheme['yellow-less'],

  'dialog_bkgrnd': colorsTheme['grey-blue'],
  'dialog_bkgrnd2': colorsTheme['grey-inactive'],
  'dialog_bkgrnd3': colorsTheme['lighterblue'],
  'dialog_txt': colorsTheme['darkblue'],
  'dialog_brdr': colorsTheme['lighterblue'],

  'global_input_bkgrnd': colorsTheme['grey-blue'],
  'global_input_bkgrnd2': colorsTheme['white-blue'],
  'global_input_bkgrnd3': '#b8c1cd',
  'global_input_hover_bkgrnd': colorsTheme['white-blue'],
  'global_input_txt': colorsTheme['blackblue'],
  'global_input_hover_txt': colorsTheme['customblue'],
  'global_input_txt2': colorsTheme['darkLightblue'],
  'global_input_txt3': colorsTheme['blackblue'],
  'global_input_highlight': '#5e5e00',
  'global_input_brdr': colorsTheme['white-blue'],
  'global_input_brdr2': colorsTheme['lightgreyblue'],
  'global_input_brdr3': colorsTheme['grey-execution-card'],

  'global_button_bkgrnd':  colorsTheme['grey-blue'],
  'global_button_bkgrnd2':  colorsTheme['grey-blueer'],
  'global_button_brdr':  colorsTheme['grey-highlight'],
  'global_button_brdr2':  colorsTheme['grey-no'],
  'global_button_txt': colorsTheme['blackblue'],
  'global_button_txt2': colorsTheme['blue'],
  'global_button_txt_hover': colorsTheme['darkLightblue'],
  'global_button_txt_hover2': colorsTheme['greyblue'],
  'global_button_success_bk': colorsTheme['default-green'],
  'global_button_danger_bk': colorsTheme['tomatoredlight'],
  // 'global_button_bkgrnd_brdr':  colorsTheme['grey-blueer'],

  // main layout Colors
  'main-background': colorsTheme['darkerblue'],
  // Header Colors
  'header-background': colorsTheme['darkblue'],
  'header-color': colorsTheme['cyan'],
  'active-background': colorsTheme['lightblue'],
  'active-color': colorsTheme['blue'],
  'active-color-dark': colorsTheme['darkblue'],
  'exit-color': colorsTheme['blue'],
  'logo-background': colorsTheme['darkblue'],
  'logo-color': colorsTheme['darkblue'],

  'enovea-green': colorsTheme['enovea-green-dark'],
  'tomato':'#690d00',
  'orange':'#8f4900',
  'steelblue': '#003660',
  'lightsteelblue': '#0f335e',
  'palegreen': '#006400',
  'yellow': '#725a00',
  'deepskyblue': '#004f6b',
  'yellowgreen': '#507700',
  'tomatored': colorsTheme['darktomatored'],
  'grass-green': colorsTheme['darkgrass-green'],
  'light-orange': colorsTheme['darkorange'],
  'light-yellow': colorsTheme['dark-light-yellow'],
  'indianred': '#830000',
  'darkorange': '#734300',
  'dodgerblue': '#003d77',
  'lightyellow': '#504c00',
  'gainsboro': '#121212',
  'darkseagreen': '#a6cfa6',
  'cornflowerblue': '#92aee1',
  'invalid': colorsTheme['red'],
  'info': colorsTheme['captionblue'],
  'yellowgreenBk': 'yellowgreen',
  'tomatoBk':'tomato',
};

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  isDarkTheme: boolean = true;
  isDarkThemeChange: Subject<boolean> = new Subject<boolean>();


  toggle() {
    this.isDarkTheme = !this.isDarkTheme;
    if (this.isDarkTheme)
      this.toggleDark()
    else
      this.toggleLight()
  }

  initDefaultTheme() {
    this.setTheme(darkTheme);
  }

  initTheme() {
    if (this.isDarkTheme)
      this.toggleDark()
    else
      this.toggleLight()
  }

  toggleDark() {
    this.setTheme(darkTheme);
    this.storageService.set(CookieNames.IS_THEME_DARK, JSON.stringify(this.isDarkTheme));
    this.isDarkThemeChange.next(this.isDarkTheme);
  }

  toggleLight() {
    this.setTheme(lightTheme);
    this.storageService.set(CookieNames.IS_THEME_DARK, JSON.stringify(this.isDarkTheme));
    this.isDarkThemeChange.next(this.isDarkTheme);
  }

  constructor(
    private storageService: CcStorageService,
    private cspStyleManager: CspStyleManager,
  ) {
    if (this.storageService.check(CookieNames.IS_THEME_DARK)) {
      if (this.storageService.get(CookieNames.IS_THEME_DARK) === 'false') {
        this.isDarkTheme = false;
      }
    }
    this.initTheme();
  }

  setProperty(key: string, value: string): void {
    this.cspStyleManager.setRootProperty(`--${key}`, value);
  }

  private setTheme(theme: {}): void {
    const props: Record<string, string> = {};
    Object.keys(theme).forEach(k => props[`--${k}`] = (theme as any)[k]);
    this.cspStyleManager.setRootProperties(props);
  }
}
